import '../scss/index.scss';
import Navbar from './navbar';

var navbar = new Navbar('navbar');

if (module.hot) {
    module.hot.accept();
}